import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';

function OnboardingLoading() {
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [currentMessage, setCurrentMessage] = useState('Setting up your personalized wellness journey...');
  const [animationStage, setAnimationStage] = useState('initial'); // initial, logo, text, progress, complete

  const loadingMessages = useMemo(() => [
    'Analyzing your responses...',
    'Creating your personalized dashboard...',
    'Setting up your wellness tools...',
    'Preparing your mental health resources...',
    'Welcome to MindBridge!'
  ], []);

  useEffect(() => {
    // Scroll to top
    window.scrollTo(0, 0);
    
    // Animation sequence
    const timer1 = setTimeout(() => {
      setAnimationStage('logo');
    }, 100);
    
    const timer2 = setTimeout(() => {
      setAnimationStage('text');
    }, 400);
    
    const timer3 = setTimeout(() => {
      setAnimationStage('progress');
    }, 700);

    // Progress bar animation
    const progressInterval = setInterval(() => {
      setProgress(prev => {
        if (prev >= 100) {
          clearInterval(progressInterval);
          setAnimationStage('complete');
          return 100;
        }
        return prev + 2;
      });
    }, 60);

    // Message rotation
    let messageIndex = 0;
    const messageInterval = setInterval(() => {
      messageIndex = (messageIndex + 1) % loadingMessages.length;
      setCurrentMessage(loadingMessages[messageIndex]);
    }, 1000);

    // Navigate to home after 5 seconds
    const navigateTimer = setTimeout(() => {
      navigate('/home');
    }, 5000);

    return () => {
      clearTimeout(timer1);
      clearTimeout(timer2);
      clearTimeout(timer3);
      clearInterval(progressInterval);
      clearInterval(messageInterval);
      clearTimeout(navigateTimer);
    };
  }, [navigate, loadingMessages]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      backgroundColor: '#f5f7fa',
      color: '#2c3e50',
      textAlign: 'center',
      padding: '20px'
    }}>
      <div style={{
        width: '100px',
        height: '100px',
        backgroundColor: '#4361ee',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '30px',
        boxShadow: '0 10px 20px rgba(67, 97, 238, 0.3)',
        opacity: animationStage === 'initial' ? 0 : 1,
        transform: animationStage === 'logo' ? 'scale(1)' : 'scale(0)',
        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1)'
      }}>
        <span style={{ fontSize: '48px', color: 'white' }}>🌉</span>
      </div>
      
      <h1 style={{ 
        fontSize: '28px', 
        fontWeight: '700', 
        marginBottom: '8px',
        color: '#2c3e50',
        opacity: animationStage === 'logo' ? 0 : 
                 animationStage === 'text' ? 1 : 1,
        transform: animationStage === 'logo' ? 'translateY(10px)' : 
                  animationStage === 'text' ? 'translateY(0)' : 'translateY(0)',
        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.2s'
      }}>
        Welcome to MindBridge
      </h1>
      
      <p style={{ 
        fontSize: '16px', 
        color: '#64748b', 
        marginBottom: '30px',
        maxWidth: '300px',
        opacity: animationStage === 'text' ? 0 : 
                 animationStage === 'progress' ? 1 : 1,
        transform: animationStage === 'text' ? 'translateY(10px)' : 
                  animationStage === 'progress' ? 'translateY(0)' : 'translateY(0)',
        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.3s'
      }}>
        {currentMessage}
      </p>
      
      {/* Progress bar */}
      <div style={{
        width: '100%',
        maxWidth: '300px',
        height: '8px',
        backgroundColor: '#e2e8f0',
        borderRadius: '4px',
        overflow: 'hidden',
        marginBottom: '20px',
        opacity: animationStage === 'progress' ? 1 : 0,
        transform: animationStage === 'progress' ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.4s'
      }}>
        <div style={{
          height: '100%',
          width: `${progress}%`,
          backgroundColor: '#4361ee',
          borderRadius: '4px',
          transition: 'width 0.3s ease-out'
        }} />
      </div>
      
      <p style={{ 
        fontSize: '14px', 
        color: '#94a3b8',
        marginBottom: '0',
        opacity: animationStage === 'progress' ? 1 : 0,
        transform: animationStage === 'progress' ? 'translateY(0)' : 'translateY(10px)',
        transition: 'all 0.5s cubic-bezier(0.34, 1.56, 0.64, 1) 0.5s'
      }}>
        {Math.round(progress)}% Complete
      </p>
    </div>
  );
}

export default OnboardingLoading;